import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useMemo, useState } from 'react';
import { generateUrl } from '@magento/peregrine/lib/util/imageUtils';
import { bool, func, number, object, oneOfType, shape, string } from 'prop-types';
import { useStyle } from '@magento/venia-ui/lib/classify'; //'../../classify';

import Icon from '@magento/venia-ui/lib/components/Icon'; //'../Icon';

import { Check as CheckIcon } from 'react-feather';
import defaultClasses from './swatch.module.css';
import { useSwatch } from '@magento/peregrine/lib/talons/ProductOptions/useSwatch';
import { Button } from '../../../../components'; //'../../../';

import { useWindowSize } from '@magento/peregrine';

var getClassName = function getClassName(name, isSelected, hasFocus) {
  return "".concat(name).concat(isSelected ? '_selected' : '').concat(hasFocus ? '_focused' : '');
}; // Swatches _must_ have a 1x1 aspect ratio to match the UI.


var SWATCH_WIDTH = 112;
var LARGE_SWATCH_WIDTH = 300; // we want a hover effect with large image popping out

var Swatch = function Swatch(props) {
  var windowSize = useWindowSize();
  var isMobile = windowSize.innerWidth <= 576;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      imageCloseUp = _useState2[0],
      setImageCloseUp = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isImageInViewport = _useState4[0],
      setIsImageInViewport = _useState4[1];

  var swatchElRef = useRef();
  var imagdeCloseUpRef = useRef();
  useEffect(function () {
    if (swatchElRef.current && imageCloseUp) {
      var _imagdeCloseUpRef$cur;

      // distance of element and header
      var topDistance = swatchElRef.current.getBoundingClientRect().top - 80; // 80 is height of sidebar header

      var itemHeight = swatchElRef.current.clientHeight / 2;
      var heightOfImageCloseUp = imagdeCloseUpRef === null || imagdeCloseUpRef === void 0 ? void 0 : (_imagdeCloseUpRef$cur = imagdeCloseUpRef.current) === null || _imagdeCloseUpRef$cur === void 0 ? void 0 : _imagdeCloseUpRef$cur.clientHeight;
      var res = topDistance - (heightOfImageCloseUp - itemHeight);
      setIsImageInViewport(res > 0 ? true : false);
    }
  }, [swatchElRef, imageCloseUp]);
  var hasFocus = props.hasFocus,
      isSelected = props.isSelected,
      _props$item = props.item,
      label = _props$item.label,
      value_index = _props$item.value_index,
      swatch_data = _props$item.swatch_data,
      onClick = props.onClick,
      style = props.style,
      isDisabled = props.isDisabled,
      _props$isResetButton = props.isResetButton,
      isResetButton = _props$isResetButton === void 0 ? false : _props$isResetButton;
  var talonProps = useSwatch({
    onClick: onClick,
    value_index: value_index
  });
  var handleClick = talonProps.handleClick;
  var icon = useMemo(function () {
    return isSelected ? React.createElement(Icon, {
      src: CheckIcon,
      alt: "Check icon"
    }) : null;
  }, [isSelected]);
  var classes = useStyle(defaultClasses, props.classes);
  var finalStyle = style;

  if (swatch_data) {
    var thumbnail = swatch_data.thumbnail,
        value = swatch_data.value;
    var swatchValue = '';

    if (value) {
      var imagePath = generateUrl(value, 'image-swatch')(LARGE_SWATCH_WIDTH);
      swatchValue = "url(\"".concat(imagePath, "\")");
    } else if (thumbnail) {
      var _imagePath = generateUrl(thumbnail, 'image-swatch')(SWATCH_WIDTH);

      swatchValue = "url(\"".concat(_imagePath, "\")");
    } else {
      swatchValue = value;
    } // We really want to avoid specifying presentation within JS.
    // Swatches are unusual in that their color is data, not presentation,
    // but applying color *is* presentational.
    // So we merely provide the color data here, and let the CSS decide
    // how to use that color (e.g., background, border).


    finalStyle = Object.assign({}, style, {
      '--venia-swatch-bg': swatchValue
    });
  }

  var imgPath = swatch_data !== null && swatch_data !== void 0 && swatch_data.value ? generateUrl(swatch_data.value, 'image-swatch')(LARGE_SWATCH_WIDTH) : false;
  var className = classes[getClassName('root', isSelected, hasFocus)];
  var hoverContentCLass = isImageInViewport ? classes.swatchCloseUpOpen : classes.swatchCloseDownOpen;
  var arrowClasses = isImageInViewport ? classes.swatchCloseDownOpenArrow : classes.swatchCloseUpOpenArrow;
  return React.createElement(React.Fragment, null, isResetButton && React.createElement("div", {
    className: "mb-4"
  }, React.createElement(Button, {
    priority: "normal",
    fullWidth: true,
    classes: {
      content: classes.btn
    },
    onClick: handleClick,
    type: "button",
    disabled: isDisabled ? true : false,
    "aria-label": "Reset default"
  }, "RESET DEFAULT")), !isResetButton && React.createElement("div", {
    className: "relative h-full"
  }, imgPath && !isMobile && React.createElement("div", {
    ref: imagdeCloseUpRef,
    className: imageCloseUp ? hoverContentCLass : classes.swatchCloseUpClosed
  }, React.createElement("div", {
    className: arrowClasses
  }, React.createElement("img", {
    src: imgPath,
    alt: "swatch close"
  }), React.createElement("p", {
    className: "pt-3 px-3 text-center pb-5 text-xs text-white bg-bronze"
  }, label))), React.createElement("div", {
    ref: swatchElRef,
    className: isSelected ? classes.itemContentSelected : classes.itemContent,
    onMouseEnter: function onMouseEnter() {
      return !isDisabled && setImageCloseUp(true);
    },
    onMouseLeave: function onMouseLeave() {
      return !isDisabled && setImageCloseUp(false);
    }
  }, isMobile && React.createElement("div", {
    className: classes.info
  }, "i"), React.createElement("button", {
    className: className + ' ' + "".concat(isDisabled ? classes.itemDisabled : ''),
    onClick: handleClick,
    style: finalStyle,
    title: label,
    type: "button",
    disabled: isDisabled ? true : '',
    "aria-label": "Disabled"
  }), React.createElement("p", {
    className: " text-xs text-bronze"
  }, label), isDisabled && React.createElement("p", {
    className: classes.itemLabelDisabled + 'text-center text-xs text-bronze'
  }, "This value is not availabe with other selections"))));
};

Swatch.propTypes = {
  hasFocus: bool,
  isSelected: bool,
  item: shape({
    label: string.isRequired,
    value_index: oneOfType([number, string]).isRequired
  }).isRequired,
  onClick: func.isRequired,
  style: object
};
Swatch.defaultProps = {
  hasFocus: false,
  isSelected: false
};
export default Swatch;